<template>
  <div>
    <div
      class="col-12 bg-white p-3 mt-3 activity-type-create tansaction-type-create"
    >
      <div class="d-flex title-bar-block mb-2">
        <div class="icon-block me-4">
          <button v-b-tooltip.hover :title="$backLabel()" @click="cancel()">
            <i class="fa fa-chevron-left text-white" aria-hidden="true"></i>
          </button>
        </div>
        <div class="text">
          <span class="me-2">{{ title }}</span>
        </div>
      </div>
      <b-overlay :show="loading" rounded="sm">
        <b-form class="form-sample" @submit.stop.prevent="createOrUpdate">
          <b-row>
            <b-col cols="12" md="6">
              <label class="mb-3"
                ><strong>{{ $nameLabel() }}</strong
                ><span class="red">*</span></label
              >
              <input
                type="text"
                v-model="model.name"
                v-custom-validation="$textRequired()"
                required
                class="form-control"
                :placeholder="$translate('enter_name')"
              />
            </b-col>
            <b-col cols="12" md="6" class="mt-of-res">
              <label class="mb-3"
                ><strong>{{ $translate("description") }}</strong></label
              >
              <input
                type="text"
                class="form-control"
                v-model="model.description"
                :placeholder="$translate('enter_description')"
              />
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" md="6" class="mt-3 dd">
              <label class="mb-3"
                ><strong>{{ $translate("entity") }}</strong
                ><span class="red">*</span></label
              >
              <b-form-select
                class="form-control"
                v-custom-validation="$selectRequired()"
                id="input-transaction_type_id"
                v-model="model.entity"
                required
                :options="entityOptions"
                :disabled="isUpdateMode"
              >
                <template #first>
                  <b-form-select-option :value="null">{{
                    $translate("select_entity")
                  }}</b-form-select-option>
                </template>
              </b-form-select>
            </b-col>
            <b-col cols="12" md="6" class="mt-3 dd">
              <label class="mb-3"
                ><strong
                  >{{ $translate("flow") }}<span class="red">*</span>
                </strong></label
              >
              <b-form-select
                class="form-control"
                v-custom-validation="$selectRequired()"
                id="input-reference-entity"
                v-model="model.flow"
                required
                :options="flowOptions"
                :disabled="isUpdateMode"
              >
                <template #first>
                  <b-form-select-option :value="null" disabled>{{
                    $translate("select_flow")
                  }}</b-form-select-option>
                </template>
              </b-form-select>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" md="12" class="my-3 dd">
              <label class="mb-3"
                ><strong
                  >{{ $translate("reference") }}<span class="red">*</span>
                </strong></label
              >
              <b-form-select
                class="form-control"
                v-custom-validation="$selectRequired()"
                required
                id="input-reference-entity"
                v-model="model.reference_entity"
                :options="referenceEntityOptions"
                :disabled="isUpdateMode"
              >
                <template #first>
                  <b-form-select-option :value="null">{{
                    $translate("select_reference_entity")
                  }}</b-form-select-option>
                </template>
              </b-form-select>
            </b-col>
          </b-row>
          <b-col class="my-3 text-center" cols="12">
            <b-button
              v-if="hasPermissionCreate && !model.id"
              type="submit"
              class="btn btn-info btn-fw me-2"
              variant="primary"
              :disabled="loading ? true : false"
              >{{ createLabel }}</b-button
            >
            <b-button
              v-if="hasPermissionUpdate && model.id"
              type="submit"
              class="btn btn-info btn-fw me-2"
              variant="primary"
              :disabled="loading ? true : false"
              >{{ updateLabel }}</b-button
            >

            <b-button
              v-if="this.model.id && hasPermissionDelete"
              @click="deleteItem()"
              size="fw"
              class="me-2"
              variant="delete-button"
            >
              {{ $deleteLabel() }}
            </b-button>
            <b-button
              variant="info"
              :disabled="loading ? true : false"
              @click="cancel()"
              class="btn-fw"
              >{{ $cancelLabel() }}</b-button
            >
          </b-col>
        </b-form>
      </b-overlay>
    </div>
  </div>
</template>
<script>
import popupMixins from "@/mixins/popupMixins";
import permissionsMixins from "@/mixins/permissionsMixins";

export default {
  name: "transactionTypes-ViewItem",
  mixins: [popupMixins, permissionsMixins],
  data() {
    return {
      componentName: "Transaction Type",
      // title: 'Transaction Type',
      model: {
        id: 0,
        name: null,
        description: null,
        flow: null,
        entity: null,
        reference_entity: null,
      },
      loading: false,
      hasErrors: false,
    };
  },
  props: ["item"],
  computed: {
    title() {
      return this.model.id
        ? this.$translate("edit_transaction_type")
        : this.$translate("new_transaction_type");
    },

    isUpdateMode() {
      return this.model.id > 0;
    },

    createLabel() {
      if (this.loading) {
        return this.$translate("creating");
      } else {
        return this.$createLabel();
      }
    },
    updateLabel() {
      if (this.loading && this.model.id) {
        return this.$translate("updating");
      } else {
        return this.$updateLabel();
      }
    },

    flows() {
      return this.$store.getters["transactionType/flows"];
    },

    entities() {
      return this.$store.getters["transactionType/entities"];
    },

    flowOptions() {
      return this.$store.getters["transactionType/flowOptions"];
    },

    entityOptions() {
      return this.$store.getters["transactionType/entityOptions"];
    },

    referenceEntityOptions() {
      const refEntityOptions = this.$store.getters[
        "transactionType/referenceEntityOptions"
      ];
      const { flow, entity } = this.model;
      return this.parseEntities(refEntityOptions, flow, entity);
    },
  },
  watch: {
    "model.flow": function () {
      if (!this.model.id) this.model.reference_entity = null;
    },
    "model.entity": function () {
      if (!this.model.id) this.model.reference_entity = null;
    },
  },
  mounted() {
    if (this.item.id) {
      this.model = { ...this.item };
    }
  },
  methods: {
    cancel() {
      this.$emit("cancel");
    },

    async deleteItem() {
      // Initializing key variables
      console.log("Attempt to delete");
      const model = { ...this.model };
      const path = "transactionType/delete";

      // Generate and display confirmation prompt
      const title = this.$translate("delete_transaction_type");
      const message = `${this.$translate("delete_note")} ${model.name}?`;
      // const errorMsg = null //'Unable to delete Transaction Type!'
      const alertMsg = this.$translate("delete_alert");

      try {
        this.loading = true;
        const result = await this.confirmMessage(title, message);
        if (result) {
          await this.$store.dispatch(path, model.id);
          this.$emit("success", this.$translate("deleted"), alertMsg);
        }
      } catch (error) {
        console.error(error);
        this.doToast(
          this.$translate("error"),
          this.$translate("unable_alert"),
          "danger"
        );
      } finally {
        this.loading = false;
      }
    },

    parseEntities(refEntityOptions, flow, entity) {
      if (this.model.id) return refEntityOptions;
      const parsedRefEntityOptions = [];
      for (const refEntity of refEntityOptions) {
        try {
          const reference_entity = refEntity.value;
          this.validateRules({ flow, entity, reference_entity });
          parsedRefEntityOptions.push(refEntity);
        } catch (err) {
          //
        }
      }
      return parsedRefEntityOptions;
    },

    validateRules({ flow, entity, reference_entity }) {
      if (flow == this.flows["Outbound"]) {
        switch (entity) {
          case this.entities["Customer"]: {
            if (
              reference_entity != this.entities["Internal"] &&
              reference_entity != this.entities["Customer"]
            ) {
              throw new Error(
                "A Customer Entity can only receive from an Internal or a Customer Entity!"
              );
            }
            break;
          }

          case this.entities["Vendor"]: {
            if (
              reference_entity != this.entities["Internal"] &&
              reference_entity != this.entities["Vendor"]
            ) {
              throw new Error(
                "A Vendor Entity can only receive from an Internal or a Vendor Entity!"
              );
            }
            break;
          }

          case this.entities["Officer"]: {
            if (
              reference_entity != this.entities["Internal"] &&
              reference_entity != this.entities["Customer"]
            ) {
              throw new Error(
                "An Officer can only receive from an Internal or a Customer Entity!"
              );
            }
            break;
          }

          case this.entities["Internal"]: {
            if (
              reference_entity != this.entities["Black Hole"] &&
              reference_entity != this.entities["Internal"]
            ) {
              throw new Error(
                "An Internal can only receive from an Internal or External Entity!"
              );
            }
            break;
          }
        }
      } else if (flow == this.flows["Inbound"]) {
        switch (entity) {
          case this.entities["Customer"]: {
            if (
              reference_entity != this.entities["Internal"] &&
              reference_entity != this.entities["Customer"]
            ) {
              throw new Error(
                "A Customer Entity can only transfer to an Internal or a Customer Entity!"
              );
            }
            break;
          }

          case this.entities["Vendor"]: {
            if (
              reference_entity != this.entities["Internal"] &&
              reference_entity != this.entities["Vendor"]
            ) {
              throw new Error(
                "A Vendor Entity can only transfer to an Internal or Vendor Entity!"
              );
            }
            break;
          }

          case this.entities["Officer"]: {
            if (
              reference_entity != this.entities["Internal"] &&
              reference_entity != this.entities["Customer"] &&
              reference_entity != this.entities["Black Hole"]
            ) {
              throw new Error(
                "An Officer can only transfer to an Internal, Loss Vault or a Customer Entity!"
              );
            }
            break;
          }

          case this.entities["Internal"]: {
            if (reference_entity != this.entities["Black Hole"]) {
              throw new Error(
                "An Internal Entity can only transfer to Loss Vault!"
              );
            }
            break;
          }
        }
      }
    },

    async createOrUpdate() {
      try {
        this.loading = true;
        const model = { ...this.model };

        console.log("model", model);
        const path = model.id
          ? "transactionType/update"
          : "transactionType/create";
        const valid = await this.$validator.validate();
        this.validateRules(model);
        if (!valid) throw new Error("Not Valid!");
        this.loading = true;
        await this.$store.dispatch(path, model);

        this.loading = false;
        const message = model.id
          ? this.$translate("updated")
          : this.$translate("created");
        this.$emit("success", message);
      } catch (error) {
        this.doToast(this.$translate("error"), error.message, "danger");
      } finally {
        this.loading = false;
      }
    },
    onSubmit() {
      console.log("test");
    },
  },
};
</script>
<style></style>
